import { Serializer } from 'jsonapi-serializer';
import { uuidv7 } from 'uuidv7';
import { SupportRequestPayload } from '../interfaces/support-request-payload.interface';

const serializer = new Serializer('SupportRequest', {
	id: 'id',
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['app', 'description', 'url', 'user'],
	typeForAttribute: (attr: string) => (attr === 'user' ? 'User' : attr),
	user: {
		ref: (record: any) => record.userId,
	},
	transform(record: any) {
		return {
			id: record.id ?? uuidv7(),
			...record,
			user: { id: record.userId },
		};
	},
});

export function serializeSupportRequest(supportRequest: SupportRequestPayload) {
	return serializer.serialize(supportRequest);
}
